import _ from 'lodash';

export const selectSuiteForm = state => _.get(state, ['suiteForm'], {});

export const selectSuiteFormData = state => _.get(selectSuiteForm(state), ['data'], {});
